<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on }">
      <img v-on="on"
        :class="{
          'elevation-4': hover,
          'invert-color': darkMode,
        }"
        class="ma-2 pa-2 skill-icon"
        :src="src"
        @mouseover="$emit('mouseover')"
        @mouseleave="$emit('mouseleave')"
      />
    </template>
    <span>{{ skill }}</span>
  </v-tooltip>
</template>

<script>
export default {
  props: ['skill', 'hover'],
  computed: {
    src() {
      let root = '/img/icons';
      return `${root}/${this.skill.toLowerCase().replace(/ /g, '_')}.svg`;
    },
    darkMode() {
      return this.$vuetify._data.dark;
    },
  },
};
</script>

<style scoped>
.skill-icon {
  border-radius: 15%;
  width: 64px;
}

.invert-color {
  filter: invert(100%);
}
</style>
